import clsx from "clsx";
import { BlockHeading } from "components/landing-pages/BlockHeading";
import { TestimonialBlock } from "dtos/content/landing-pages/TestimonialBlock";

export const TestimonialBlockDisplay = (props: { block: TestimonialBlock }) => {
    const { block } = props;
    const { person1, person2, person3, heading } = block;

    return (
        <div className="grid">
            {heading && (
                <div className="g-col-12">
                    <BlockHeading block={block} />
                </div>
            )}

            {[person1, person2, person3].map((person, index) => {
                const bgColor = index === 1 ? "bg-danger" : "bg-success";

                return (
                    <div key={index} className="g-col-12 g-col-lg-4">
                        <div className={clsx("text-center h-100 p-4 text-white", bgColor)}>
                            <div className="vstack gap-3 h-100 justify-content-between">
                                <div className="h0">🙌</div>

                                <div className="font-family-serif fw-normal h4">"{person.quote}"</div>

                                <div className="lh-1">&mdash; {person.person}</div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
